import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot, Routes, CanActivate } from '@angular/router';

import { UserRouteAccessService } from '../../shared';
import { PaginationUtil } from 'ng-jhipster';

import { NewsArticleComponent } from './news-article.component';
import { NewsArticleDetailComponent } from './news-article-detail.component';
import { NewsArticlePopupComponent } from './news-article-dialog.component';
import { NewsArticleDeletePopupComponent } from './news-article-delete-dialog.component';

import { Principal } from '../../shared';

@Injectable()
export class NewsArticleResolvePagingParams implements Resolve<any> {

  constructor(private paginationUtil: PaginationUtil) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
      let page = route.queryParams['page'] ? route.queryParams['page'] : '1';
      let sort = route.queryParams['sort'] ? route.queryParams['sort'] : 'id,asc';
      return {
          page: this.paginationUtil.parsePage(page),
          predicate: this.paginationUtil.parsePredicate(sort),
          ascending: this.paginationUtil.parseAscending(sort)
    };
  }
}

export const newsArticleRoute: Routes = [
  {
    path: 'news-article',
    component: NewsArticleComponent,
    resolve: {
      'pagingParams': NewsArticleResolvePagingParams
    },
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'jYoguiApp.newsArticle.home.title'
    }
  }, {
    path: 'news-article/:id',
    component: NewsArticleDetailComponent,
    data: {
        authorities: ['ROLE_USER'],
        pageTitle: 'jYoguiApp.newsArticle.home.title'
    }
  }
];

export const newsArticlePopupRoute: Routes = [
  {
    path: 'news-article-new',
    component: NewsArticlePopupComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.newsArticle.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'news-article/:id/edit',
    component: NewsArticlePopupComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.newsArticle.home.title'
    },
    outlet: 'popup'
  },
  {
    path: 'news-article/:id/delete',
    component: NewsArticleDeletePopupComponent,
    data: {
        authorities: ['ROLE_ADMIN', 'ROLE_SCHOOL_ADMIN'],
        pageTitle: 'jYoguiApp.newsArticle.home.title'
    },
    outlet: 'popup'
  }
];



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/news-article/news-article.route.ts